const prettifyFieldName = (field: string) =>
  field
    .replace(/([A-Z])/g, " $1")
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const contextualValidationMessage = (
  pageName: string,
  errors: Record<string, string | undefined>,
  fallback: string,
) => {
  const fields = Object.entries(errors)
    .filter(([, message]) => Boolean(message))
    .map(([field, message]) => {
      const fieldName = prettifyFieldName(field);
      const cleanMessage = String(message || "").replace(/\.$/, "");
      return cleanMessage || fieldName;
    })
    .slice(0, 3);

  if (!fields.length) return fallback;

  const remainingCount =
    Object.values(errors).filter(Boolean).length - fields.length;
  const suffix =
    remainingCount > 0 ? ` and ${remainingCount} more field${remainingCount === 1 ? "" : "s"}` : "";

  return `${pageName}: ${fields.join(", ")}${suffix}.`;
};
